module.exports = {"attack":{"id":229,"name":"Empty","icon":""},"strength":{"id":229,"name":"Empty","icon":""},"ranged":{"id":229,"name":"Empty","icon":""},"magic":{"id":229,"name":"Empty","icon":""}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/potions/default.json
// module id = CTBV
// module chunks = 1